export const appendQueryParams = (params) => {
  if (!params) return "";

  let result = "";
  let index = 0;

  for (const [key, value] of Object.entries(params)) {
    if (key &&  value !== undefined && value !== null) {
      result += `${index ? "&" : "?"}${key}=${value}`;
    }

    index++;
  }

  return result;
};
